import { FormContainerStepProps } from 'components';
import { useTranslation } from 'libs/i18n';
import {
  ClientType,
  FormBodyWrapper,
} from 'modules/onboarding/common/components';

import { NameFormType, FormErrors, getSchema } from '../../forms/nameForm';

import { FormContent } from './FormContent';

interface Props extends FormContainerStepProps {
  initialValues?: NameFormType;
  onSubmit: (values: NameFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitLoading?: boolean;
  clientType?: ClientType;
}

export const Name = ({
  initialValues,
  canGoBack,
  onGoBack,
  submitLoading,
  clientType,
  formError,
  onSubmit,
  step,
  ...formProps
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema();
  return (
    <FormBodyWrapper
      canGoBack={canGoBack}
      clientType={clientType}
      initialErrors={formError}
      initialValues={initialValues}
      step={step}
      submitLoading={submitLoading}
      subTitle={t('onboarding.legalClientBranch.name.subtitle')}
      title={t('onboarding.legalClientBranch.name.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <FormContent {...formProps} />
    </FormBodyWrapper>
  );
};
